import qs from 'store/entities/QueryString';
import defined from 'defined';
import Feature from './Feature';
import * as tags from './Tags';

const firstDefined = (...fns) => feature =>
  defined.apply(defined, fns.map(fn => fn(feature)));

// eslint-disable-next-line no-unused-vars
const getParam = () => feature => {
  // cannot shortcircuit because we're trying to find the first boolean value
  if (qs.has(feature.name)) {
    return qs.get(feature.name);
  }
};
const getBooleanParam = () => feature => {
  if (qs.has(feature.name)) {
    return qs.getBoolean(feature.name);
  }
};

// a tag is always a boolean
const hasTag = tag => feature => {
  if (qs.has(tag)) {
    return qs.getBoolean(tag);
  }
};
const always = () => feature => true;
const never = () => feature => false;

// similar to pipe
const default2018Q2 = firstDefined(hasTag(tags.tag2018Q2), never());
const default2018Q3 = firstDefined(hasTag(tags.tag2018Q3), always()); // Q3 features are always enabled

export function get2018Q2Features() {
  // prettier-ignore
  return [{
    name: '$phoneSearch',
    label: 'Enable search by phone',
    tags: [tags.tag2018Q2]
  }].map(feature =>
    Object.assign({
      getValue: getBooleanParam(),
      getDefaultValue: default2018Q2
    }, feature)
  );
}

export function get2018Q3Features() {
  // prettier-ignore
  return [{
    name: '$phoneEmailSearch',
    label: 'Enable search by phone & email',
    tags: [tags.tag2018Q3]
  }, {
    name: '$servicePackages',
    label: 'Show service packages',
    tags: [tags.tag2018Q3]
  }, {
    name: '$saveToCalendar',
    label: 'Save to calendar',
    tags: [tags.tag2018Q3]
  }, {
    name: '$otherServices',
    label: 'Show other services',
    tags: [tags.tag2018Q3]
  }, {
    name: '$editAppointment',
    label: 'Enable edit appointment',
    tags: [tags.tag2018Q3]
  }, {
    name: '$socialLogin',
    label: 'Show Social Login Buttons',
    tags: [tags.tag2018Q3]
  }, {
    name: '$signInButton',
    label: 'Show Sign In Button',
    tags: [tags.tag2018Q3]
  }].map(feature => Object.assign({
    getValue: getBooleanParam(),
    getDefaultValue: default2018Q3
  }, feature));
}

function getMetaFeatures() {
  // prettier-ignore
  return [{
    name: '$gtm',
    label: 'Google Tag Manager token',
    type: 'string',
    getValue: getParam(),
    getDefaultValue: () => window.DEFAULT_GTM_TOKEN
  }].map(feature => Object.assign({
    tags: [tags.tagMeta]
  }, feature));
}

function getServerFeatures() {
  // TODO: get defaults from server, props should be synchronized manually
  // prettier-ignore
  return [{
    name: '$features',
    label: 'Enable feature toggler',
    getDefaultValue: never()
  }, {
    name: '$enableCloudfront',
    label: 'Enable cloudfront',
    getDefaultValue: always()
  }, {
    name: '$enableInjectConsumerEndpoint',
    label: 'Inject consumer endpoint',
    getDefaultValue: always()
  }, {
    name: '$enableInjectDealerData',
    label: 'Inject dealer data',
    getDefaultValue: always()
  }, {
    name: '$theme',
    label: 'Theme',
    type: 'string',
    getValue: getParam(),
    getDefaultValue: () => 'default'
  }].map(feature => Object.assign({
    tags: [tags.tagServer],
    getValue: getBooleanParam()
  }, feature));
}

function initialize() {
  [
    ...get2018Q2Features(),
    ...get2018Q3Features(),
    ...getServerFeatures(),
    ...getMetaFeatures()
  ].forEach(config => Feature.add(new Feature(config)));
}

export default initialize;



// WEBPACK FOOTER //
// ./src/components/atoms/Feature/featureInitializer.js